module.exports = __webpack_public_path__ + "img/undraw_os_upgrade_nj2m.bd7861f9.svg";